module.exports = "https://assets.pclncdn.com/web/next-landing/967f96dee0/_next/static/images/new-york-city-ef179cdee55fdfea4dd59b401b23a904.jpg";